import { useEffect, useRef } from 'react'
import { useToast } from '../../context/useToast'
import { isNoSignInPreviewActive } from '../../debug'
import { subscribeWorkspaceSocialEvents, type WorkspaceSocialEvent } from '../../services/reliabilityService'

const storageKey = (workspaceId: string) => `timelining:seen-social-events:${workspaceId}`

const readSeen = (workspaceId: string) => {
  if (typeof window === 'undefined') return new Set<string>()
  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey(workspaceId)) ?? '[]')
    return new Set(Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [])
  } catch {
    return new Set<string>()
  }
}

const writeSeen = (workspaceId: string, seen: Set<string>) => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(storageKey(workspaceId), JSON.stringify(Array.from(seen).slice(-50)))
}

const toastForEvent = (event: WorkspaceSocialEvent) => {
  if (event.type === 'RAID_COMPLETED') return `Raid completed: ${event.title}`
  if (event.type === 'RAID_STARTED') return `Milestone raid started: ${event.title}`
  return ''
}

export const RaidCelebration = ({ workspaceId }: { workspaceId: string | null | undefined }) => {
  const { showToast } = useToast()
  const primedRef = useRef(false)

  useEffect(() => {
    primedRef.current = false
    if (!workspaceId || isNoSignInPreviewActive()) return undefined
    const seen = readSeen(workspaceId)
    return subscribeWorkspaceSocialEvents(workspaceId, (events) => {
      if (!primedRef.current) {
        events.forEach((event) => seen.add(event.id))
        writeSeen(workspaceId, seen)
        primedRef.current = true
        return
      }
      events
        .slice()
        .reverse()
        .forEach((event) => {
          if (seen.has(event.id)) return
          seen.add(event.id)
          const message = toastForEvent(event)
          if (message) showToast(message, event.type === 'RAID_COMPLETED' ? 'success' : 'ghost')
        })
      writeSeen(workspaceId, seen)
    }, (error) => {
      console.warn('[RaidCelebration] social event subscription failed', error)
    })
  }, [showToast, workspaceId])

  return null
}
